<template>
  <div>
    <Topbar title="Commandes" />

    <section class="Section" v-if="error">
      <div class="OrderList__error">
        {{ error }}
      </div>
    </section>

    <section class="Section" v-if="isLoading || pendingOrders.length > 0">
      <div class="Section__header" v-if="!isLoading">
        <h2 class="Section__title">En cours</h2>
      </div>
      <div class="OrderList">
        <router-link :to="{name: 'Order', params: { id: order.id }}" v-for="order in pendingOrders" :key="order.id">
          <OrderCard v-bind="order" />
        </router-link>
      </div>
    </section>

    <section class="Section" v-if="isLoading || processedOrders.length > 0">
      <div class="Section__header" v-if="!isLoading">
        <h2 class="Section__title">Passées</h2>
      </div>
      <div class="OrderList">
        <router-link :to="{name: 'Order', params: { id: order.id }}" v-for="order in processedOrders" :key="order.id">
          <OrderCard v-bind="order" />
        </router-link>
      </div>
    </section>

    <section class="Section" v-if="!isLoading && pendingOrders.length === 0">
      <div class="Section__empty">
        <p>Toujours pas de commande<br />auprès du Captain...<br /><br />Est-ce bien sérieux ?</p>
        <img
          style="max-height: 30vh;"
          src="../assets/images/monkey.png"
          alt="Un singe avec un chapeau de marin tenant une bouteille de vin avec une référence à Walt Whitman…"
        />
        <router-link class="Button Button--primary" :to="{name: 'Home'}">Découvrez nos offres</router-link>
      </div>
    </section>

  </div>
</template>

<script>
import orderService from "../services/order";
import OrderCard from "../components/OrderCard";

export default {
  data() {
    return {
      orders: [],
      error: ""
    };
  },
  computed: {
    pendingOrders() {
      return this.orders.filter(order => !order.completed);
    },
    processedOrders() {
      return this.orders.filter(order => order.completed);
    }
  },
  created() {
    this.isLoading = true;

    orderService.getAll()
      .then(({ data: orders }) => {
        this.orders = orders;
      })
      .catch(() => this.error = "Une erreur est survenue lors de la récupération de vos commandes, nous avons été prévenu du problème.\n\nMerci de réessayer ultérieurement.")
      .finally(() => this.isLoading = false);
  },
  components: { OrderCard }
};
</script>

<style lang="scss" scoped>
@import "../assets/variables";

.OrderList {
  &__error {
    padding: $global-margin;
    text-align: center;
    white-space: pre;
  }
}
</style>
